<template>
  <div class="container">
    <h2>{{ sect.field_2 }}</h2>
    <p v-if="sect.field_3" v-html="sect.field_3"></p>

    <transition-group name="articles" tag="div" class="row">
      <div
        v-for="(article, index) in pages.loaded"
        class="col-12 col-md-6 col-lg-4"
        v-bind:key="index + article.id"
      >
        <a class="item news_item_link" @click="showVideo(article.youtubeId)" href="javascript:;">
          <div class="image bglazyload" :data-src="article.banner"></div>
          <div class="copy">
            <div class="article-category">{{ article.category_title }}</div>
            <div class="article-title">{{ article.heading }}</div>
          </div>
          <div class="btn-square">
            <i class="icon icon-arrow"></i>
          </div>
        </a>
        <modal :name="article.youtubeId" width="100%" height="100%" :maxWidth="640" :maxHeight="360" :adaptive="true">
            <youtube :video-id="article.youtubeId"  ref="youtube" :player-vars="playerVars" >
                <img :src="article.banner" />
                </youtube>
        </modal>

      </div>

    </transition-group>

    <button
      v-if="showButton"
      v-on:click="getVideos"
      class="article-list-btn btn btn-white-blue btn-hover"
    >{{ load_more }}</button>
    <div class="article-list-loader">
      <img v-if="showLoader" src="/cdn/images/loaders/ball-clip-rotate-multiple.gif" class="loader" />
    </div>
  </div>
</template>
<script>
import ObserveForLazyLoad from "../../js/lazyload";
export default {
  props: {
    section: {
      section: Object,
      required: true
    },
    load_more: {
      section: String,
      default: "Load More"
    }
  },
  data() {
    return {
      page: 1,
      pageLength: 6,
      endpoint: "api/video-list/",
      responsedata: [],
      pages: {
        loaded: []
      },
      playerVars: {
        autoplay: 1,
        rel : 0
      },
      showLoader: false
    };
  },
  mounted() {
    this.getVideos();
  },
  updated() {
    ObserveForLazyLoad.ObserveForLazyLoad();
  },
  methods: {
      showVideo(youtubeId){
          this.$modal.show(youtubeId);

      },
    async getVideos() {
      try {
        this.showLoader = true;
        var page_category_id = this.sect.field_1 || 0;
        var apiUrl =
          this.endpoint +
          [page_category_id, this.pageLength, this.page].join("/");
        var response = await axios.get(apiUrl);
        this.responsedata = response.data.data;

        this.pages.loaded = this.pages.loaded.concat(this.responsedata);
        this.page++;

        this.showLoader = false;
      } catch (err) {
        console.log(err);
      }
    }
  },
  computed: {
    sect: function() {
      return JSON.parse(this.section);
    },
    showButton: function() {
      if (
        this.responsedata.length === 0 ||
        this.responsedata.length < this.pageLength
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>
<style scoped>
.v--modal-box > iframe {
  width: 100%;
  max-width: 650px;
}
</style>